export const GOOGLE_AUTHENTICATOR_URL = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US';
export const AUTHY_URL = 'https://authy.com/download/';
